import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";

//Components
import { Select, Switch as Toggle, Pill } from '@gpstrackit/gtc-react-controls';
import Slider from "Components/Slider";
import { Grid } from '@mui/material';

//Helpers
import { HasPermission } from "Core/security";

const General = (props) => {
    const { messages } = useIntl();
    const {
        formDataCamera,
        setFormDataCamera,
        setCameraChanges,
        vehicleClass,
        setVehicleClass,
        vehicleClassOptions,
        unit,
        deviceModelSelected
    } = props    //Variables
    let cameraOrientationOptions = [
        { id: "normal", label: messages['cameraSetup_normal'], color: '#66bb6a', },
        { id: "upsidedown", label: messages['cameraSetup_upside_down'], color: '#f1f1f1', }
    ]

    let auxOrientationOptions = [
        { id: "normal", label: messages['cameraSetup_normal'], color: '#66bb6a', },
        { id: "upsidedown", label: messages['cameraSetup_upside_down'], color: '#f1f1f1', },
        { id: "rotate_right", label: messages['cameraSetup_rotate_right'], color: '#f1f1f1', },
        { id: "rotate_left", label: messages['cameraSetup_rotate_left'], color: '#f1f1f1', }
    ]

    const user = useSelector((state) => state.securityRedux.user);


    useEffect(() => {
        if (formDataCamera && !vehicleClass) {
            let newVehicleClass = vehicleClassOptions.find(opt => {
                const eventThreshold = opt.eventThreshold;
                return eventThreshold &&
                    eventThreshold?.accValue === formDataCamera?.eventThreshold?.accValue &&
                    eventThreshold?.brakeValue === formDataCamera?.eventThreshold?.brakeValue &&
                    eventThreshold?.turnValue === formDataCamera?.eventThreshold?.turnValue &&
                    eventThreshold?.accDuration === formDataCamera?.eventThreshold?.accDuration &&
                    eventThreshold?.brakeDuration === formDataCamera?.eventThreshold?.brakeDuration &&
                    eventThreshold?.turnDuration === formDataCamera?.eventThreshold?.turnDuration
            });
            if (newVehicleClass) {
                setVehicleClass(newVehicleClass)
            }
        }
    }, [formDataCamera])

    return (
        <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{ width: '100%', marginTop: 5 }}
            spacing={1}
        >
            <Grid item xs={12}>
                <Select
                    id="input-vehicle-class"
                    value={vehicleClass}
                    onChange={(value) => {
                        setVehicleClass(value)
                        setFormDataCamera((prevData) => ({
                            ...prevData,
                            eventThreshold: value?.eventThreshold
                        }));
                        setCameraChanges((prevData) => ({
                            ...prevData,
                            eventThreshold: value?.eventThreshold
                        }));
                    }}
                    options={vehicleClassOptions || []}
                    textField="name"
                    valueField="id"
                    label={messages['cameraSetup_vehicle_class']}
                    placeholder={messages['cameraSetup_vehicle_class']}
                    isDisabled={formDataCamera?.noData}
                />
            </Grid>
            {
                HasPermission(user, ['vfdrid'], [284]) &&
                <Grid item xs={12} className="camera-setup-general-container">
                    <label className="label-gtc-rc">{messages['cameraSetup_driver_id']}</label>
                    <Toggle
                        id="driver-id"
                        optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                        onChange={(value) => {
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                advanced: {
                                    ...prevData?.advanced,
                                    driverID: {
                                        ...prevData?.advanced?.driverID,
                                        uploadFace: value
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                advanced: {
                                    ...prevData?.advanced,
                                    driverID: {
                                        ...prevData?.advanced?.driverID,
                                        uploadFace: value
                                    }
                                }
                            }));
                        }}
                        checked={formDataCamera?.advanced?.driverID?.uploadFace}
                        labelPosition="left"
                        style={{ display: 'flex', justifyContent: 'end' }}
                        isDisabled={formDataCamera?.noData}
                    />
                </Grid>
            }
            {
                (unit?.deviceModel === "360" || deviceModelSelected?.id === "360") &&
                <Grid item xs={12}>
                    <label className="label-gtc-rc">{messages['cameraSetup_camera_orientation']}</label>
                    <div style={{ display: 'flex', marginTop: 5 }}>
                        {cameraOrientationOptions.map((filter, index) => {
                            return (
                                <Pill
                                    key={index}
                                    textField={'label'}
                                    item={{ ...filter, color: (formDataCamera?.rotate || "upsidedown") === filter?.id ? "#66bb6a" : "#f1f1f1" }}
                                    onClick={() => {
                                        if (!formDataCamera?.noData) {
                                            setFormDataCamera((prevData) => ({
                                                ...prevData,
                                                rotate: filter?.id
                                            }));
                                            setCameraChanges((prevData) => ({
                                                ...prevData,
                                                rotate: filter?.id
                                            }));
                                        }
                                    }}
                                    style={{ border: '0', width: '100%', textAlign: 'center' }}
                                    label="pill-label-text"
                                    size="filled"
                                />
                            )
                        })}
                    </div>
                </Grid>
            }
            {
                (formDataCamera?.advanced?.aux?.model && formDataCamera?.advanced?.aux?.model !== "NA") &&
                <Grid item xs={12}>
                    <label className="label-gtc-rc">{messages['cameraSetup_aux_one_orientation']}</label>
                    <div style={{ display: 'flex', marginTop: 5 }}>
                        {auxOrientationOptions.map((filter, index) => {
                            return (
                                <Pill
                                    key={index}
                                    textField={'label'}
                                    item={{ ...filter, color: formDataCamera?.advanced?.aux?.angle === filter?.id ? "#66bb6a" : "#f1f1f1" }}
                                    onClick={() => {
                                        if (!formDataCamera?.noData) {
                                            if (unit?.deviceModel === "AIR2" || deviceModelSelected?.id === "AIR2") {
                                                setFormDataCamera((prevData) => ({
                                                    ...prevData,
                                                    advanced: {
                                                        ...prevData?.advanced,
                                                        aux: {
                                                            ...prevData?.advanced?.aux,
                                                            angle: filter?.id,
                                                            angle2: filter?.id
                                                        }
                                                    }
                                                }));
                                                setCameraChanges((prevData) => ({
                                                    ...prevData,
                                                    advanced: {
                                                        ...prevData?.advanced,
                                                        adas: {
                                                            level: formDataCamera?.advanced?.adas?.level
                                                        },
                                                        aux: {
                                                            ...prevData?.advanced?.aux,
                                                            ...formDataCamera?.advanced?.aux,
                                                            angle: filter?.id,
                                                            angle2: filter?.id
                                                        },
                                                        privacyControl: {
                                                            ...formDataCamera?.advanced?.privacyControl
                                                        }
                                                    },
                                                    dms: {
                                                        level: formDataCamera?.dms?.level
                                                    },
                                                    recordConfig: formDataCamera?.recordConfig
                                                }));
                                            } else {
                                                setFormDataCamera((prevData) => ({
                                                    ...prevData,
                                                    advanced: {
                                                        ...prevData?.advanced,
                                                        aux: {
                                                            ...prevData?.advanced?.aux,
                                                            angle: filter?.id
                                                        }
                                                    }
                                                }));
                                                setCameraChanges((prevData) => ({
                                                    ...prevData,
                                                    advanced: {
                                                        ...prevData?.advanced,
                                                        aux: {
                                                            ...prevData?.advanced?.aux,
                                                            angle: filter?.id
                                                        }
                                                    }
                                                }));
                                            }
                                        }
                                    }}
                                    style={{ border: '0', width: '100%', textAlign: 'center' }}
                                    label="pill-label-text"
                                    size="filled"
                                />
                            )
                        })}
                    </div>
                </Grid>
            }
            {
                (unit?.deviceModel === "AIR2" || deviceModelSelected?.id === "AIR2") && formDataCamera?.advanced?.aux?.model2 !== "NA" &&
                <Grid item xs={12}>
                    <label className="label-gtc-rc">{messages['cameraSetup_aux_two_orientation']}</label>
                    <div style={{ display: 'flex', marginTop: 5 }}>
                        {auxOrientationOptions.map((filter, index) => {
                            let angleRestrictionSimple = ["normal", "upsidedown"]
                            let angleRestrictionOther = ["rotate_right", "rotate_left"]
                            let isDisabled = (filter?.id === "rotate_right" && angleRestrictionSimple.includes(formDataCamera?.advanced?.aux?.angle)) ||
                                (filter?.id === "rotate_left" && angleRestrictionSimple.includes(formDataCamera?.advanced?.aux?.angle)) ||
                                (filter?.id === "normal" && angleRestrictionOther.includes(formDataCamera?.advanced?.aux?.angle)) ||
                                (filter?.id === "upsidedown" && angleRestrictionOther.includes(formDataCamera?.advanced?.aux?.angle))
                            return (
                                <div style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}>
                                    <Pill
                                        key={index}
                                        textField={'label'}
                                        item={{ ...filter, color: formDataCamera?.advanced?.aux?.angle2 === filter.id ? "#66bb6a" : "#f1f1f1" }}
                                        onClick={() => {
                                            if (!formDataCamera?.noData) {
                                                setFormDataCamera((prevData) => ({
                                                    ...prevData,
                                                    advanced: {
                                                        ...prevData?.advanced,
                                                        aux: {
                                                            ...prevData?.advanced?.aux,
                                                            angle2: filter?.id
                                                        }
                                                    }
                                                }));
                                                setCameraChanges((prevData) => ({
                                                    ...prevData,
                                                    advanced: {
                                                        ...prevData?.advanced,
                                                        aux: {
                                                            ...prevData?.advanced?.aux,
                                                            angle2: filter?.id
                                                        }
                                                    }
                                                }));
                                            }
                                        }}
                                        style={{ border: '0', width: '100%', textAlign: 'center' }}
                                        label="pill-label-text"
                                        size="filled"
                                        disabled={isDisabled}
                                        clickable={isDisabled}
                                    />
                                </div>
                            )
                        })}
                    </div>
                </Grid>
            }
            <Grid item xs={12}>
                <label className="label-gtc-rc">{messages['cameraSetup_volume']}</label>
                <div>
                    <Slider
                        min={0}
                        max={10}
                        value={!formDataCamera?.noData ? formDataCamera?.volume?.speaker : 7}
                        onChange={(value) => {
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                volume: {
                                    ...prevData?.volume,
                                    speaker: value
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                volume: {
                                    ...prevData?.volume,
                                    speaker: value
                                }
                            }));
                        }}
                        valueLabelDisplay={"off"}
                        sliderStep={1}
                        showValue={true}
                        disabled={formDataCamera?.noData}
                    />
                </div>
            </Grid>
        </Grid>
    )
}
export default General